import React from "react";

import dotenv from 'dotenv';

import i18nNext from 'i18next';
import CsStrapi from "../csStrapi/csStrapi";

let cs18n_list = [],
    cs18n_missing_list = [],
    handler_post = null;

function handlerMissingKey(lng, ns, key, fallbackValue) {
    let lang = i18nNext.language;
    if (!lang)
        lang = 'en';
    if (cs18n_list[key]) {
        return;
    }

    cs18n_list[key] = key;
    let data;

    if (lang === "en") {
        data = { lang: lang, key: key, text: key };
    } else {
        data = { lang: lang, key: key, text: "" };
    }
    cs18n_missing_list.push(data);
    postMissingData();
}

function postMissingData() {
    if (handler_post)
        return;
    const count = cs18n_missing_list.length;
    handler_post = setTimeout(() => {
        if (count !== cs18n_missing_list.length) {
            handler_post = null;
            postMissingData();
            return;
        }

        dotenv.config();

        let token = process.env.REACT_APP_STRAPI_POST_KEY;
        let data = [];
        // let path = window.location.pathname;
        for (let item of cs18n_missing_list) {
            data.push({ ...item });
        }
        cs18n_missing_list = [];
        handler_post = null;

        if (token) {
            CsI18n.debugHandler('Translation: Preparing to create missing translations', { token: token, items: data });
            CsStrapi.post(
                process.env.REACT_APP_STRAPI_TRANS_DATA,
                {},
                { token: token, items: data },
                (result) => {
                    CsI18n.debugHandler('Translation: Create translation entries:', result);
                    // Invalidate cache to fetch latest data later
                    CsI18n.removeCache(CsI18n.getCacheKey());
                },
                (...args) => {
                    CsI18n.debugHandler('Translation: Create translation failed!', ...args);
                    // Due to poor implementation in API server, we also need to invalid cache when failed! 
                    CsI18n.removeCache(CsI18n.getCacheKey());
                },
                true,
                CsI18n.debugHandler
            );
        } else {
            CsI18n.debugHandler('Translation: Token is undefined');
        }
    }, 3000);
}

export class CsI18n extends React.Component {
    static langCode = '';
    static debug = false;
    static refreshResource = false;

    static getCache = () => undefined;
    static setCache = () => undefined;
    static removeCache = () => undefined;
    static debugHandler = () => undefined;

    static log(...args) {
        if (this.debug) {
            console.log('---Translation: ', ...args);
        }
    }

    static getCacheKey() {
        return "CsI18n_Cache." + CsI18n.langCode;
    }

    static init(lang, isDebug, debugHandler, funcGetCache, funcSetCache, funcRemoveCache, refreshResource = false) {
        CsI18n.langCode = lang;
        CsI18n.debug = isDebug;
        CsI18n.refreshResource = refreshResource;
        CsI18n.getCache = funcGetCache;
        CsI18n.setCache = funcSetCache;
        CsI18n.removeCache = funcRemoveCache;
        CsI18n.debugHandler = debugHandler;
        if (!CsI18n.langCode) {
            return Promise.reject("Language is not set!");
        }

        return CsI18n.loadResource(lang)
            .then(resource => {
                return i18nNext.init({
                    debug: isDebug,
                    resources: {
                        [lang]: { translation: CsI18n.parseResource(resource) },
                    },
                    interpolation: {
                        escapeValue: false, // not needed for react as it escapes by default
                    },
                    keySeparator: false,
                    nsSeparator: false,
                    saveMissing: true,
                    missingKeyHandler: handlerMissingKey,
                })
            })
            .then(t => {
                CsI18n.log('i18next initialize', t);
                return i18nNext.changeLanguage(lang);
            })
            .then(r => {
                this.log('Change language to', lang, r);
                // All done, do main logic
                return Promise.resolve(lang);
            });
    }

    static loadResource(langCode) {
        const resource = CsI18n.getCache(CsI18n.getCacheKey());
        if (resource && Array.isArray(resource) && !this.refreshResource) {
            return Promise.resolve(resource);
        } else {
            return this.requestExternalResource(langCode);
        }
    }

    static parseResource(resource) {
        let result = {};
        for (const item of resource) {
            let csKey = item.key.trim();
            cs18n_list[csKey] = csKey;
            result[csKey] = item.text;
        }
        return result;
    }

    static requestExternalResource(langCode) {
        dotenv.config();
        return CsStrapi.getNormal(process.env.REACT_APP_STRAPI_TRANS_DATA, { lang: langCode, _limit: 1000 })
            .then(result => {
                this.log('Fetch done:', result);
                return new Promise((resolve, reject) => {
                    if (Array.isArray(result)) {
                        CsI18n.setCache(CsI18n.getCacheKey(), result);
                        resolve(result);
                    } else {
                        reject('Translation resource is malformed!');
                    }
                })
            });
    }

    static t(key, options = null) {
        key = typeof (key) === "string" ? key.trim() : key;
        let text = i18nNext.t(key, options);
        return (typeof text === 'undefined' || text === null || text.length === 0) ? key : text;
    }

    state = {
        key: "",
        options: {}
    }

    constructor(props) {
        super(props);
        let { children, ...options } = this.props;
        this.state.key = children;
        this.state.options = options;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let { children, ...options } = nextProps;
        this.setState({ key: children, options: options })
    }

    convertJSX(text) {
        let options = {};
        let count = 0;
        for (let key in this.state.options) {
            if (typeof (this.state.options[key]) === "object") {
                count++;
                options[key] = `{{${key}}}`;
            } else {
                options[key] = this.state.options[key];
            }
        }

        text = CsI18n.t(text, options);
        if (count === 0)
            return [text];

        let items = text.split(/{{[^{}]+}}/);
        let exp = /{{([^{}]+)}}/g;
        let params = [];
        let match;
        while ((match = exp.exec(text))) {
            params.push(match[1]);
        }

        let jsx = [];
        for (let i = 0; i < items.length; i++) {
            jsx.push(items[i]);
            if (i !== (items.length - 1)) {
                if (this.state.options[params[i]].key) {
                    jsx.push(this.state.options[params[i]]);
                } else {
                    jsx.push(React.cloneElement(this.state.options[params[i]], { key: this.state.options[params[i]].key + i }));
                }
            }
        }

        return jsx;
    }

    render() {
        let text;
        if (typeof (this.state.key) === "string") {
            text = this.convertJSX(this.state.key);

        } else {
            text = [];
            for (let item of this.state.key) {
                if (typeof (item) === "string") {
                    text.concat(this.convertJSX(item));
                } else {
                    text.push(item);
                }
            }
        }
        return (<React.Fragment>
            {text}
        </React.Fragment>);
    }
}
